import { RouteComponentProps, withRouter } from 'react-router';
import React from 'react';
import { logout } from '../../components/auth/redux/authActions';
import ModalContainer from '../../elements/ModalContainer/ModalContainer';
import modal from "./../../elements/ModalContainer/ModalContainer.module.scss";
import Button from '../../elements/Button/Button';
import strings from '../../lang/lang';

type PropsType = RouteComponentProps<any> & {
  hide: () => void;
  visibility: boolean;
};

class SessionOutdated extends React.Component<PropsType, any> {
  render() {
    const { visibility, hide } = this.props as any;

    return (
      <ModalContainer
        isOpen={visibility || false}
        closeModalWindow={() => hide()}
        title={strings.sessionOutdated.text.title}
        header={strings.sessionOutdated.text.description}
      >
        <div className={modal["react-modal__btn-box"]}>
          <Button
            name={strings.sessionOutdated.buttons.logout}
            type="submit"
            variant="primary"
            secondaryClassName="popup_primary"
            onClick={async () => {
              await logout();
            }}
          />

        </div>
        <Button name={strings.sessionOutdated.buttons.cancel} type="submit" variant="secondary" secondaryClassName="popup_secondary" onClick={() => hide()} />
      </ModalContainer>
    );
  }
}

export default withRouter(SessionOutdated);
